/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * TreePlotter v3 API
 * TreePlotter v3 API
 * OpenAPI spec version: 4.53.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  AddPhotosParams,
  AddPhotosToAsset,
  ArchiveAssetParams,
  Asset,
  AssetPhotos,
  BadRequestResponse,
  CreateAsset,
  CreateAssetParams,
  CreateAssetResponse,
  DeleteAssetParams,
  ForbiddenErrorResponse,
  GetAllPhotosByAssetParams,
  GetAssetParams,
  GetAssetsFromWorkTaskIdsParams,
  GetAssetsFromWorkTaskIdsRequest,
  GetAssetsFromWorkTaskIdsResponse,
  GetAssetsParams,
  GetReviewedAssetIdsRequest,
  GetReviewedAssetIdsResponse,
  Id,
  RemovePhotosFromAsset,
  UnarchiveAssetParams,
  UnauthorizedErrorResponse,
  UpdateAsset,
  UpdateAssetParams,
} from ".././model";

import { httpClient } from "../../../src/common/infrastructure/api/http-client";

export const importAssets = (assetClassId: Id, signal?: AbortSignal) => {
  return httpClient<void>({
    url: `/command-service/asset-class/service/asset-import/${assetClassId}/import-assets`,
    method: "POST",
    signal,
  });
};

export const getImportAssetsMutationOptions = <
  TError = UnauthorizedErrorResponse | void,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof importAssets>>,
    TError,
    { assetClassId: Id },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof importAssets>>,
  TError,
  { assetClassId: Id },
  TContext
> => {
  const mutationKey = ["importAssets"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof importAssets>>,
    { assetClassId: Id }
  > = (props) => {
    const { assetClassId } = props ?? {};

    return importAssets(assetClassId);
  };

  return { mutationFn, ...mutationOptions };
};

export type ImportAssetsMutationResult = NonNullable<
  Awaited<ReturnType<typeof importAssets>>
>;

export type ImportAssetsMutationError = UnauthorizedErrorResponse | void;

export const useImportAssets = <
  TError = UnauthorizedErrorResponse | void,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof importAssets>>,
      TError,
      { assetClassId: Id },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof importAssets>>,
  TError,
  { assetClassId: Id },
  TContext
> => {
  const mutationOptions = getImportAssetsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get assets
 */
export const getAssets = (
  tenantId: Id,
  params: GetAssetsParams,
  signal?: AbortSignal
) => {
  return httpClient<Asset[]>({
    url: `/query-service/tenant/${tenantId}/asset-information/get-assets`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetAssetsQueryKey = (
  tenantId?: Id,
  params?: GetAssetsParams
) => {
  return [
    "query-service",
    "tenant",
    tenantId,
    "asset-information",
    "get-assets",
    ...(params ? [params] : []),
  ] as const;
};

export const getGetAssetsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAssets>>,
  TError = ForbiddenErrorResponse | void
>(
  tenantId: Id,
  params: GetAssetsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAssets>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAssetsQueryKey(tenantId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAssets>>> = ({
    signal,
  }) => getAssets(tenantId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!tenantId,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getAssets>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetAssetsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAssets>>
>;
export type GetAssetsQueryError = ForbiddenErrorResponse | void;

export function useGetAssets<
  TData = Awaited<ReturnType<typeof getAssets>>,
  TError = ForbiddenErrorResponse | void
>(
  tenantId: Id,
  params: GetAssetsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAssets>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssets>>,
          TError,
          Awaited<ReturnType<typeof getAssets>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAssets<
  TData = Awaited<ReturnType<typeof getAssets>>,
  TError = ForbiddenErrorResponse | void
>(
  tenantId: Id,
  params: GetAssetsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAssets>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAssets>>,
          TError,
          Awaited<ReturnType<typeof getAssets>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAssets<
  TData = Awaited<ReturnType<typeof getAssets>>,
  TError = ForbiddenErrorResponse | void
>(
  tenantId: Id,
  params: GetAssetsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAssets>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get assets
 */

export function useGetAssets<
  TData = Awaited<ReturnType<typeof getAssets>>,
  TError = ForbiddenErrorResponse | void
>(
  tenantId: Id,
  params: GetAssetsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAssets>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAssetsQueryOptions(tenantId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Fetch assets associated with the given work task IDs and return a bounding box for initial map centering. The response bounding box is calculated from ALL matching assets, regardless of the optional request bounding box filter.
 * @summary Get assets from work task IDs
 */
export const getAssetsFromWorkTaskIds = (
  tenantId: Id,
  getAssetsFromWorkTaskIdsRequest: GetAssetsFromWorkTaskIdsRequest,
  params: GetAssetsFromWorkTaskIdsParams,
  signal?: AbortSignal
) => {
  return httpClient<GetAssetsFromWorkTaskIdsResponse>({
    url: `/query-service/tenant/${tenantId}/asset-information/get-assets-from-work-task-ids`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: getAssetsFromWorkTaskIdsRequest,
    params,
    signal,
  });
};

export const getGetAssetsFromWorkTaskIdsMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedErrorResponse
    | ForbiddenErrorResponse
    | void,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getAssetsFromWorkTaskIds>>,
    TError,
    {
      tenantId: Id;
      data: GetAssetsFromWorkTaskIdsRequest;
      params: GetAssetsFromWorkTaskIdsParams;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getAssetsFromWorkTaskIds>>,
  TError,
  {
    tenantId: Id;
    data: GetAssetsFromWorkTaskIdsRequest;
    params: GetAssetsFromWorkTaskIdsParams;
  },
  TContext
> => {
  const mutationKey = ["getAssetsFromWorkTaskIds"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getAssetsFromWorkTaskIds>>,
    {
      tenantId: Id;
      data: GetAssetsFromWorkTaskIdsRequest;
      params: GetAssetsFromWorkTaskIdsParams;
    }
  > = (props) => {
    const { tenantId, data, params } = props ?? {};

    return getAssetsFromWorkTaskIds(tenantId, data, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetAssetsFromWorkTaskIdsMutationResult = NonNullable<
  Awaited<ReturnType<typeof getAssetsFromWorkTaskIds>>
>;
export type GetAssetsFromWorkTaskIdsMutationBody =
  GetAssetsFromWorkTaskIdsRequest;
export type GetAssetsFromWorkTaskIdsMutationError =
  | BadRequestResponse
  | UnauthorizedErrorResponse
  | ForbiddenErrorResponse
  | void;

/**
 * @summary Get assets from work task IDs
 */
export const useGetAssetsFromWorkTaskIds = <
  TError =
    | BadRequestResponse
    | UnauthorizedErrorResponse
    | ForbiddenErrorResponse
    | void,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof getAssetsFromWorkTaskIds>>,
      TError,
      {
        tenantId: Id;
        data: GetAssetsFromWorkTaskIdsRequest;
        params: GetAssetsFromWorkTaskIdsParams;
      },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof getAssetsFromWorkTaskIds>>,
  TError,
  {
    tenantId: Id;
    data: GetAssetsFromWorkTaskIdsRequest;
    params: GetAssetsFromWorkTaskIdsParams;
  },
  TContext
> => {
  const mutationOptions = getGetAssetsFromWorkTaskIdsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Given a batch of asset IDs, returns the subset that already has a TreeD-typed inspection submitted against it (TP3-497). Backed by each asset's folded event stream, not a stored field — an asset ID not in the response has no TreeD inspection on record.

 * @summary Get which of the given assets already have a TreeD inspection
 */
export const getReviewedAssetIds = (
  tenantId: Id,
  getReviewedAssetIdsRequest: GetReviewedAssetIdsRequest,
  signal?: AbortSignal
) => {
  return httpClient<GetReviewedAssetIdsResponse>({
    url: `/query-service/tenant/${tenantId}/asset-information/get-reviewed-asset-ids`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: getReviewedAssetIdsRequest,
    signal,
  });
};

export const getGetReviewedAssetIdsMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedErrorResponse
    | ForbiddenErrorResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getReviewedAssetIds>>,
    TError,
    { tenantId: Id; data: GetReviewedAssetIdsRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getReviewedAssetIds>>,
  TError,
  { tenantId: Id; data: GetReviewedAssetIdsRequest },
  TContext
> => {
  const mutationKey = ["getReviewedAssetIds"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getReviewedAssetIds>>,
    { tenantId: Id; data: GetReviewedAssetIdsRequest }
  > = (props) => {
    const { tenantId, data } = props ?? {};

    return getReviewedAssetIds(tenantId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetReviewedAssetIdsMutationResult = NonNullable<
  Awaited<ReturnType<typeof getReviewedAssetIds>>
>;
export type GetReviewedAssetIdsMutationBody = GetReviewedAssetIdsRequest;
export type GetReviewedAssetIdsMutationError =
  | BadRequestResponse
  | UnauthorizedErrorResponse
  | ForbiddenErrorResponse;

/**
 * @summary Get which of the given assets already have a TreeD inspection
 */
export const useGetReviewedAssetIds = <
  TError =
    | BadRequestResponse
    | UnauthorizedErrorResponse
    | ForbiddenErrorResponse,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof getReviewedAssetIds>>,
      TError,
      { tenantId: Id; data: GetReviewedAssetIdsRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof getReviewedAssetIds>>,
  TError,
  { tenantId: Id; data: GetReviewedAssetIdsRequest },
  TContext
> => {
  const mutationOptions = getGetReviewedAssetIdsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Create asset
 */
export const createAsset = (
  tenantId: Id,
  assetId: Id,
  createAsset: CreateAsset,
  params: CreateAssetParams,
  signal?: AbortSignal
) => {
  return httpClient<CreateAssetResponse | void>({
    url: `/command-service/tenant/${tenantId}/asset-class/aggregate/asset/${assetId}/create-asset`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createAsset,
    params,
    signal,
  });
};

export const getCreateAssetMutationOptions = <
  TError = void | UnauthorizedErrorResponse | ForbiddenErrorResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createAsset>>,
    TError,
    { tenantId: Id; assetId: Id; data: CreateAsset; params: CreateAssetParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createAsset>>,
  TError,
  { tenantId: Id; assetId: Id; data: CreateAsset; params: CreateAssetParams },
  TContext
> => {
  const mutationKey = ["createAsset"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createAsset>>,
    { tenantId: Id; assetId: Id; data: CreateAsset; params: CreateAssetParams }
  > = (props) => {
    const { tenantId, assetId, data, params } = props ?? {};

    return createAsset(tenantId, assetId, data, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateAssetMutationResult = NonNullable<
  Awaited<ReturnType<typeof createAsset>>
>;
export type CreateAssetMutationBody = CreateAsset;
export type CreateAssetMutationError =
  | void
  | UnauthorizedErrorResponse
  | ForbiddenErrorResponse;

/**
 * @summary Create asset
 */
export const useCreateAsset = <
  TError = void | UnauthorizedErrorResponse | ForbiddenErrorResponse,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createAsset>>,
      TError,
      {
        tenantId: Id;
        assetId: Id;
        data: CreateAsset;
        params: CreateAssetParams;
      },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createAsset>>,
  TError,
  { tenantId: Id; assetId: Id; data: CreateAsset; params: CreateAssetParams },
  TContext
> => {
  const mutationOptions = getCreateAssetMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get asset
 */
export const getAsset = (
  tenantId: Id,
  params: GetAssetParams,
  signal?: AbortSignal
) => {
  return httpClient<Asset>({
    url: `/query-service/tenant/${tenantId}/asset-information/get-asset`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetAssetQueryKey = (tenantId?: Id, params?: GetAssetParams) => {
  return [
    "query-service",
    "tenant",
    tenantId,
    "asset-information",
    "get-asset",
    ...(params ? [params] : []),
  ] as const;
};

export const getGetAssetQueryOptions = <
  TData = Awaited<ReturnType<typeof getAsset>>,
  TError = ForbiddenErrorResponse | void
>(
  tenantId: Id,
  params: GetAssetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAsset>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAssetQueryKey(tenantId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAsset>>> = ({
    signal,
  }) => getAsset(tenantId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!tenantId,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getAsset>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetAssetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAsset>>
>;
export type GetAssetQueryError = ForbiddenErrorResponse | void;

export function useGetAsset<
  TData = Awaited<ReturnType<typeof getAsset>>,
  TError = ForbiddenErrorResponse | void
>(
  tenantId: Id,
  params: GetAssetParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAsset>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAsset>>,
          TError,
          Awaited<ReturnType<typeof getAsset>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAsset<
  TData = Awaited<ReturnType<typeof getAsset>>,
  TError = ForbiddenErrorResponse | void
>(
  tenantId: Id,
  params: GetAssetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAsset>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAsset>>,
          TError,
          Awaited<ReturnType<typeof getAsset>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAsset<
  TData = Awaited<ReturnType<typeof getAsset>>,
  TError = ForbiddenErrorResponse | void
>(
  tenantId: Id,
  params: GetAssetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAsset>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get asset
 */

export function useGetAsset<
  TData = Awaited<ReturnType<typeof getAsset>>,
  TError = ForbiddenErrorResponse | void
>(
  tenantId: Id,
  params: GetAssetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAsset>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAssetQueryOptions(tenantId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get all asset photos
 */
export const getAllPhotosByAsset = (
  tenantId: Id,
  params: GetAllPhotosByAssetParams,
  signal?: AbortSignal
) => {
  return httpClient<AssetPhotos[]>({
    url: `/query-service/tenant/${tenantId}/asset-information/get-asset-photos`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetAllPhotosByAssetQueryKey = (
  tenantId?: Id,
  params?: GetAllPhotosByAssetParams
) => {
  return [
    "query-service",
    "tenant",
    tenantId,
    "asset-information",
    "get-asset-photos",
    ...(params ? [params] : []),
  ] as const;
};

export const getGetAllPhotosByAssetQueryOptions = <
  TData = Awaited<ReturnType<typeof getAllPhotosByAsset>>,
  TError = ForbiddenErrorResponse | void
>(
  tenantId: Id,
  params: GetAllPhotosByAssetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllPhotosByAsset>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAllPhotosByAssetQueryKey(tenantId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAllPhotosByAsset>>
  > = ({ signal }) => getAllPhotosByAsset(tenantId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!tenantId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAllPhotosByAsset>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAllPhotosByAssetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAllPhotosByAsset>>
>;
export type GetAllPhotosByAssetQueryError = ForbiddenErrorResponse | void;

export function useGetAllPhotosByAsset<
  TData = Awaited<ReturnType<typeof getAllPhotosByAsset>>,
  TError = ForbiddenErrorResponse | void
>(
  tenantId: Id,
  params: GetAllPhotosByAssetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllPhotosByAsset>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllPhotosByAsset>>,
          TError,
          Awaited<ReturnType<typeof getAllPhotosByAsset>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAllPhotosByAsset<
  TData = Awaited<ReturnType<typeof getAllPhotosByAsset>>,
  TError = ForbiddenErrorResponse | void
>(
  tenantId: Id,
  params: GetAllPhotosByAssetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllPhotosByAsset>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllPhotosByAsset>>,
          TError,
          Awaited<ReturnType<typeof getAllPhotosByAsset>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetAllPhotosByAsset<
  TData = Awaited<ReturnType<typeof getAllPhotosByAsset>>,
  TError = ForbiddenErrorResponse | void
>(
  tenantId: Id,
  params: GetAllPhotosByAssetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllPhotosByAsset>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get all asset photos
 */

export function useGetAllPhotosByAsset<
  TData = Awaited<ReturnType<typeof getAllPhotosByAsset>>,
  TError = ForbiddenErrorResponse | void
>(
  tenantId: Id,
  params: GetAllPhotosByAssetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAllPhotosByAsset>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetAllPhotosByAssetQueryOptions(
    tenantId,
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const updateAsset = (
  tenantId: Id,
  assetId: Id,
  updateAsset: UpdateAsset,
  params: UpdateAssetParams,
  signal?: AbortSignal
) => {
  return httpClient<void>({
    url: `/command-service/tenant/${tenantId}/asset-class/aggregate/asset/${assetId}/update-asset`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: updateAsset,
    params,
    signal,
  });
};

export const getUpdateAssetMutationOptions = <
  TError = void | UnauthorizedErrorResponse | ForbiddenErrorResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateAsset>>,
    TError,
    { tenantId: Id; assetId: Id; data: UpdateAsset; params: UpdateAssetParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateAsset>>,
  TError,
  { tenantId: Id; assetId: Id; data: UpdateAsset; params: UpdateAssetParams },
  TContext
> => {
  const mutationKey = ["updateAsset"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateAsset>>,
    { tenantId: Id; assetId: Id; data: UpdateAsset; params: UpdateAssetParams }
  > = (props) => {
    const { tenantId, assetId, data, params } = props ?? {};

    return updateAsset(tenantId, assetId, data, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateAssetMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateAsset>>
>;
export type UpdateAssetMutationBody = UpdateAsset;
export type UpdateAssetMutationError =
  | void
  | UnauthorizedErrorResponse
  | ForbiddenErrorResponse;

export const useUpdateAsset = <
  TError = void | UnauthorizedErrorResponse | ForbiddenErrorResponse,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateAsset>>,
      TError,
      {
        tenantId: Id;
        assetId: Id;
        data: UpdateAsset;
        params: UpdateAssetParams;
      },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateAsset>>,
  TError,
  { tenantId: Id; assetId: Id; data: UpdateAsset; params: UpdateAssetParams },
  TContext
> => {
  const mutationOptions = getUpdateAssetMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Delete asset
 */
export const deleteAsset = (
  tenantId: Id,
  assetId: Id,
  params: DeleteAssetParams,
  signal?: AbortSignal
) => {
  return httpClient<void>({
    url: `/command-service/tenant/${tenantId}/asset-class/aggregate/asset/${assetId}/delete-asset`,
    method: "POST",
    params,
    signal,
  });
};

export const getDeleteAssetMutationOptions = <
  TError = ForbiddenErrorResponse | void,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteAsset>>,
    TError,
    { tenantId: Id; assetId: Id; params: DeleteAssetParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteAsset>>,
  TError,
  { tenantId: Id; assetId: Id; params: DeleteAssetParams },
  TContext
> => {
  const mutationKey = ["deleteAsset"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteAsset>>,
    { tenantId: Id; assetId: Id; params: DeleteAssetParams }
  > = (props) => {
    const { tenantId, assetId, params } = props ?? {};

    return deleteAsset(tenantId, assetId, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteAssetMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteAsset>>
>;

export type DeleteAssetMutationError = ForbiddenErrorResponse | void;

/**
 * @summary Delete asset
 */
export const useDeleteAsset = <
  TError = ForbiddenErrorResponse | void,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteAsset>>,
      TError,
      { tenantId: Id; assetId: Id; params: DeleteAssetParams },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteAsset>>,
  TError,
  { tenantId: Id; assetId: Id; params: DeleteAssetParams },
  TContext
> => {
  const mutationOptions = getDeleteAssetMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Archive asset
 */
export const archiveAsset = (
  tenantId: Id,
  assetId: Id,
  params: ArchiveAssetParams,
  signal?: AbortSignal
) => {
  return httpClient<void>({
    url: `/command-service/tenant/${tenantId}/asset-class/aggregate/asset/${assetId}/archive-asset`,
    method: "POST",
    params,
    signal,
  });
};

export const getArchiveAssetMutationOptions = <
  TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof archiveAsset>>,
    TError,
    { tenantId: Id; assetId: Id; params: ArchiveAssetParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof archiveAsset>>,
  TError,
  { tenantId: Id; assetId: Id; params: ArchiveAssetParams },
  TContext
> => {
  const mutationKey = ["archiveAsset"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof archiveAsset>>,
    { tenantId: Id; assetId: Id; params: ArchiveAssetParams }
  > = (props) => {
    const { tenantId, assetId, params } = props ?? {};

    return archiveAsset(tenantId, assetId, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type ArchiveAssetMutationResult = NonNullable<
  Awaited<ReturnType<typeof archiveAsset>>
>;

export type ArchiveAssetMutationError =
  | UnauthorizedErrorResponse
  | ForbiddenErrorResponse
  | void;

/**
 * @summary Archive asset
 */
export const useArchiveAsset = <
  TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof archiveAsset>>,
      TError,
      { tenantId: Id; assetId: Id; params: ArchiveAssetParams },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof archiveAsset>>,
  TError,
  { tenantId: Id; assetId: Id; params: ArchiveAssetParams },
  TContext
> => {
  const mutationOptions = getArchiveAssetMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const unarchiveAsset = (
  tenantId: Id,
  assetId: Id,
  params: UnarchiveAssetParams,
  signal?: AbortSignal
) => {
  return httpClient<void>({
    url: `/command-service/tenant/${tenantId}/asset-class/aggregate/asset/${assetId}/unarchive-asset`,
    method: "POST",
    params,
    signal,
  });
};

export const getUnarchiveAssetMutationOptions = <
  TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unarchiveAsset>>,
    TError,
    { tenantId: Id; assetId: Id; params: UnarchiveAssetParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof unarchiveAsset>>,
  TError,
  { tenantId: Id; assetId: Id; params: UnarchiveAssetParams },
  TContext
> => {
  const mutationKey = ["unarchiveAsset"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof unarchiveAsset>>,
    { tenantId: Id; assetId: Id; params: UnarchiveAssetParams }
  > = (props) => {
    const { tenantId, assetId, params } = props ?? {};

    return unarchiveAsset(tenantId, assetId, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type UnarchiveAssetMutationResult = NonNullable<
  Awaited<ReturnType<typeof unarchiveAsset>>
>;

export type UnarchiveAssetMutationError =
  | UnauthorizedErrorResponse
  | ForbiddenErrorResponse
  | void;

export const useUnarchiveAsset = <
  TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof unarchiveAsset>>,
      TError,
      { tenantId: Id; assetId: Id; params: UnarchiveAssetParams },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof unarchiveAsset>>,
  TError,
  { tenantId: Id; assetId: Id; params: UnarchiveAssetParams },
  TContext
> => {
  const mutationOptions = getUnarchiveAssetMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const addPhotos = (
  tenantId: Id,
  assetId: Id,
  addPhotosToAsset: AddPhotosToAsset,
  params: AddPhotosParams,
  signal?: AbortSignal
) => {
  return httpClient<void>({
    url: `/command-service/tenant/${tenantId}/asset-class/aggregate/asset/${assetId}/add-photos`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: addPhotosToAsset,
    params,
    signal,
  });
};

export const getAddPhotosMutationOptions = <
  TError = void | UnauthorizedErrorResponse | ForbiddenErrorResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addPhotos>>,
    TError,
    {
      tenantId: Id;
      assetId: Id;
      data: AddPhotosToAsset;
      params: AddPhotosParams;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addPhotos>>,
  TError,
  {
    tenantId: Id;
    assetId: Id;
    data: AddPhotosToAsset;
    params: AddPhotosParams;
  },
  TContext
> => {
  const mutationKey = ["addPhotos"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addPhotos>>,
    {
      tenantId: Id;
      assetId: Id;
      data: AddPhotosToAsset;
      params: AddPhotosParams;
    }
  > = (props) => {
    const { tenantId, assetId, data, params } = props ?? {};

    return addPhotos(tenantId, assetId, data, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddPhotosMutationResult = NonNullable<
  Awaited<ReturnType<typeof addPhotos>>
>;
export type AddPhotosMutationBody = AddPhotosToAsset;
export type AddPhotosMutationError =
  | void
  | UnauthorizedErrorResponse
  | ForbiddenErrorResponse;

export const useAddPhotos = <
  TError = void | UnauthorizedErrorResponse | ForbiddenErrorResponse,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof addPhotos>>,
      TError,
      {
        tenantId: Id;
        assetId: Id;
        data: AddPhotosToAsset;
        params: AddPhotosParams;
      },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof addPhotos>>,
  TError,
  {
    tenantId: Id;
    assetId: Id;
    data: AddPhotosToAsset;
    params: AddPhotosParams;
  },
  TContext
> => {
  const mutationOptions = getAddPhotosMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const removePhotos = (
  tenantId: Id,
  assetId: Id,
  removePhotosFromAsset: RemovePhotosFromAsset,
  signal?: AbortSignal
) => {
  return httpClient<void>({
    url: `/command-service/tenant/${tenantId}/asset-class/aggregate/asset/${assetId}/remove-photos`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: removePhotosFromAsset,
    signal,
  });
};

export const getRemovePhotosMutationOptions = <
  TError = void | UnauthorizedErrorResponse | ForbiddenErrorResponse,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removePhotos>>,
    TError,
    { tenantId: Id; assetId: Id; data: RemovePhotosFromAsset },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof removePhotos>>,
  TError,
  { tenantId: Id; assetId: Id; data: RemovePhotosFromAsset },
  TContext
> => {
  const mutationKey = ["removePhotos"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof removePhotos>>,
    { tenantId: Id; assetId: Id; data: RemovePhotosFromAsset }
  > = (props) => {
    const { tenantId, assetId, data } = props ?? {};

    return removePhotos(tenantId, assetId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RemovePhotosMutationResult = NonNullable<
  Awaited<ReturnType<typeof removePhotos>>
>;
export type RemovePhotosMutationBody = RemovePhotosFromAsset;
export type RemovePhotosMutationError =
  | void
  | UnauthorizedErrorResponse
  | ForbiddenErrorResponse;

export const useRemovePhotos = <
  TError = void | UnauthorizedErrorResponse | ForbiddenErrorResponse,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof removePhotos>>,
      TError,
      { tenantId: Id; assetId: Id; data: RemovePhotosFromAsset },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof removePhotos>>,
  TError,
  { tenantId: Id; assetId: Id; data: RemovePhotosFromAsset },
  TContext
> => {
  const mutationOptions = getRemovePhotosMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
